import type { InternalPage } from '../lib/pages.ts'

/**
 * Every page in the internal webapp, in the order the rail shows them.
 *
 * This file is the builder lane. It sits under `src/routes/` rather than in
 * `src/lib/` so that adding a page needs no code-owner review: `src/lib/` is
 * owned in full by `.github/CODEOWNERS`, and every page ever added to this
 * repo had to edit the list when it lived there. The shape and the grouping
 * logic stay in `src/lib/pages.ts`, which is framework and stays owned.
 *
 * The `-` prefix is TanStack Router's ignore prefix, so this file adds no
 * route. Add an entry when you add a route under `src/routes/<app>/`, and
 * `-nav.test.ts` fails if you forget.
 *
 * The rail in `__root.tsx` is the only reader. Every signed-in employee sees
 * every entry: per-page access control was removed while no page needed it, so
 * there is no per-viewer answer to ask for.
 */
export const INTERNAL_PAGES: readonly InternalPage[] = Object.freeze([
  {
    id: 'blytzcollect-analytics',
    path: '/blytzcollect/analytics',
    title: 'BlytzCollect Analytics'
  },
  {
    id: 'ach-returns',
    path: '/payments/ach-returns',
    title: 'ACH returns'
  },
  {
    id: 'bin-mcc-fee-report',
    path: '/payments/bin-mcc-fee-report',
    title: 'BIN / MCC fee report'
  },
  {
    id: 'multicard-usage',
    path: '/payments/multicard-usage',
    title: 'Multicard Usage'
  },
  {
    id: 'retry-analysis',
    path: '/reports/retry-analysis',
    title: 'Retry Analysis'
  },
  {
    id: 'cs-tools-autopay-accounts',
    path: '/cs-tools/autopay-accounts',
    title: 'Autopay Accounts',
    group: 'CS Tools'
  },
  {
    id: 'ai-texts',
    path: '/reports/ai-texts',
    title: 'AI Texts'
  },
  {
    id: 'cs-tools-merchant-notes',
    path: '/cs-tools/merchant-notes',
    title: 'Merchant Notes',
    group: 'CS Tools'
  }
])
